import { createContext } from "react";

import { LogMessageType } from "../api/types";

export type NotificationContextType = {
  notifications: LogMessageType[];
  write: (message: LogMessageType) => void;
};

// this default state is only used when no provided is found
// so it's mostly a "stub" implementation
const initialState = { notifications: [], write: () => {} };

export default createContext<NotificationContextType>(initialState);
